import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = ["src"];
import { watch, ref } from 'vue';
import { useLess } from '@/models/hooks';
import { ASIN_ITEM_BADGES_LIST } from '@/configs/common';
import { ASIN_ITEM_ICONS_URLS } from '@/configs/imageLink';
export default {
  __name: 'AsinTag',
  props: {
    // Display type
    type: {
      type: String,
      default: 'default'
    },
    // Display the color of the border when the type is default or text has a value
    borderColor: {
      type: String
    },
    // Display the color of the text when it has a value
    color: {
      type: String
    },
    // text content
    text: {
      type: String
    }
  },
  setup(__props) {
    var props = __props;
    useLess('components/tags.less');
    var imgUrl = ref('');
    watch(props, data => {
      if (ASIN_ITEM_ICONS_URLS[data.type]) {
        imgUrl.value = ASIN_ITEM_ICONS_URLS[data.type];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("img", {
        src: imgUrl.value,
        alt: "",
        class: _normalizeClass({
          'tag-scale': _unref(ASIN_ITEM_BADGES_LIST).includes(__props.type)
        })
      }, null, 10, _hoisted_1), [[_vShow, imgUrl.value]]), __props.type === 'default' && __props.text ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "default-tag",
        style: _normalizeStyle({
          'border-color': __props.borderColor,
          color: __props.color
        })
      }, _toDisplayString(__props.text), 5)) : _createCommentVNode("", true)], 64);
    };
  }
};